export default "__VITE_ASSET__VJgCpgf9__"